"use client"
/* */
import { createContext, useContext } from 'react';

const tabContext = createContext({
  id: "undefined"
});
const useTabContext = () => useContext(tabContext);
const TabContextProvider = tabContext.Provider;

export { TabContextProvider, useTabContext };
//# sourceMappingURL=context.mjs.map
